'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UITextInput from 'UIComponents/input/UITextInput';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import { KEYS as Keys } from 'DesignData/enums/Keys';
import ValidatedFilenameControl from 'DesignComponents/form/ValidatedFilenameControl';
import { Header, Form, Footer } from 'DesignFinderUI/components/forms/dropdownForm';
export default class NewFolderForm extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      folderName: ''
    };

    this.getI18nKey = key => `${this.props.i18nKey}.${key}`;

    this.onConfirm = () => {
      const {
        folderName
      } = this.state;
      this.props.callback({
        folderName: folderName.trim()
      });
    };

    this.onCancel = () => {
      this.props.callback(false);
    };

    this.onFormSubmit = evt => {
      evt.preventDefault();
      this.onConfirm();
    };

    this.onKeydown = evt => {
      if (evt.keyCode === Keys.ESCAPE) {
        this.onCancel();
      }
    };

    this.onFolderNameError = () => {
      this.setState({
        folderName: ''
      });
    };

    this.onFolderNameSuccess = folderName => {
      this.setState({
        folderName
      });
    };

    this.setInputRef = ref => {
      this.__input = ref;
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  render() {
    const {
      folderName
    } = this.state;
    return /*#__PURE__*/_jsx(ToolFieldset, {
      children: /*#__PURE__*/_jsxs(Form, {
        onSubmit: this.onFormSubmit,
        children: [/*#__PURE__*/_jsx(Header, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: this.getI18nKey('header')
          })
        }), /*#__PURE__*/_jsx(ValidatedFilenameControl, {
          allowEmpty: true,
          htmlFor: "folderName",
          label: text(this.getI18nKey('input.label')),
          labelClassName: "p-top-0",
          onError: this.onFolderNameError,
          onSuccess: this.onFolderNameSuccess,
          required: true,
          children: /*#__PURE__*/_jsx(UITextInput, {
            defaultValue: folderName,
            maxLength: 100,
            name: "folderName",
            placeholder: text(this.getI18nKey('input.placeholder')),
            autoFocus: true
          })
        }), /*#__PURE__*/_jsxs(Footer, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "new-folder__create-button",
            disabled: !folderName.trim(),
            onClick: this.onConfirm,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: this.getI18nKey('buttons.create')
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: this.onCancel,
            use: "secondary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: this.getI18nKey('buttons.cancel')
            })
          })]
        })]
      })
    });
  }

}
NewFolderForm.displayName = 'NewFolderForm';
NewFolderForm.propTypes = {
  callback: PropTypes.func.isRequired,
  i18nKey: PropTypes.string
};
NewFolderForm.defaultProps = {
  i18nKey: 'DesignFinderUI.forms.NewFolderForm'
};